import React, { Component } from "react";
import { Row, Col, UncontrolledAlert, Card, Button, CardBody } from "reactstrap";
import { MdAdd } from "react-icons/md";
import Formsy from "formsy-react";
import { Spinner } from "../Shared";
import { TextInput } from "../Shared/Forms";

class FoodMetricForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
        };
    }

    disableButton = () => {
        this.setState({ canSubmit: false });
    };

    enableButton = () => {
        this.setState({ canSubmit: true });
    };

    handleSubmit = (data) => {
   
        let requestBody = {
            name: data && data.name,
        };
        if (this.props.hasParams) {
      
            this.props.editAction(requestBody);
        } else {
            this.props.submitAction(requestBody);
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.submitSucessful) {
            this.resetForm();
        }
    }

    resetForm = () => {
        this.refs.foodMetricForm.reset();
    };

    ClearDescription = () => {
        this.props.reset();
        this.resetForm();
    };

    render() {
        const { canSubmit } = this.state;
        const { submitting, error, hasParams, selectedRow } = this.props;
        return (
            <div>
                <Row>
                    <Col sm="5">
                        {error ? <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert> : null}
                        <Formsy ref="foodMetricForm" onValidSubmit={this.handleSubmit} onValid={this.enableButton} onInvalid={this.disableButton} noValidate>
                            <TextInput
                                name="name"
                                value={selectedRow && hasParams ? selectedRow.name : null}
                                required
                                disabled={submitting}
                                title="Name"
                                validations={{
                                    minLength: 3,
                                    maxLength: 50,
                                }}
                                validationErrors={{
                                    minLength: "Minimum of 3 characters allowed",
                                }}
                            />
                            <Button type="submit" color="primary" disabled={!canSubmit || submitting}>
                                {submitting ? (
                                    <Spinner size="sm" />
                                ) : (
                                    <span>
                                        {hasParams ? "Update" : "Create"} <MdAdd size={20} />
                                    </span>
                                )}
                            </Button>{" "}
                            {hasParams ? (
                                <Button type="button" outline color="primary" onClick={() => this.ClearDescription()}>
                                    Reset
                                </Button>
                            ) : null}
                        </Formsy>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default FoodMetricForm;
